export default __webpack_public_path__ + "static/media/spaceXhub3.b7041fab.png";